import {
  Card,
  CardContent,
  List,
  Grid,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  makeStyles,
  colors,
  CardActions,
  Typography,
  Link,
} from "@material-ui/core";
import { KeyboardArrowRight } from "@material-ui/icons";
import React from "react";

const useStyle = makeStyles((theme) => ({
  green: {
    color: theme.palette.getContrastText(colors.green[400]),
    backgroundColor: colors.green[400],
  },
}));

export function ReportCard(props) {
  const { data } = props;
  const classes = useStyle();
  const preventDefault = (event) => event.preventDefault();

  const reportCardData = {
    bestValueCollege: {
      title: "Best Value College",
      value: data.rankingsBestColleges
        ? getGradeFromRanking(data.rankingsBestColleges)
        : "?",
    },
    bestCollegeAcademics: {
      title: "Best College Academics",
      value: data.rankingsBestCollegeAcademics
        ? getGradeFromRanking(data.rankingsBestCollegeAcademics)
        : "?",
    },
    mostDiverseCollege: {
      title: "Most Diverse College",
      value: data.rankingsMostDiverseColleges
        ? getGradeFromRanking(data.rankingsMostDiverseColleges)
        : "?",
    },
    bestCollegeCampuse: {
      title: "Best College Campuses",
      value: data.rankingsBestCollegeCampuses
        ? getGradeFromRanking(data.rankingsBestCollegeCampuses)
        : "?",
    },
    bestCollegeAthletics: {
      title: "Best College Athletic",
      value: data.rankingsBestCollegeAthletics
        ? getGradeFromRanking(data.rankingsBestCollegeAthletics)
        : "?",
    },
    bestCollegeForBiology: {
      title: "Best College For Biology",
      value: data.rankingsBestCollegesForBiology
        ? getGradeFromRanking(data.rankingsBestCollegesForBiology)
        : "?",
    },
  };

  return (
    <>
      <Card>
        <CardContent>
          <Grid container>
            {Object.keys(reportCardData).map((key, index) => (
              <Grid item sm={6} key={index}>
                <List>
                  <ListItem>
                    <ListItemAvatar>
                      <Avatar className={classes.green}>
                        {reportCardData[key].value}
                      </Avatar>
                    </ListItemAvatar>
                    <ListItemText>{reportCardData[key].title}</ListItemText>
                  </ListItem>
                </List>
              </Grid>
            ))}
          </Grid>
        </CardContent>
        <hr className="mb-0" />
        <CardActions>
          <Typography variant="body1" color="primary" className="ml-auto mr-2">
            <Link
              href={window.location.href + "/grades"}
              onLClick={preventDefault}
            >
              See All <KeyboardArrowRight />
            </Link>
          </Typography>
        </CardActions>
      </Card>
    </>
  );
}

function getGradeFromRanking({ value, total }) {
  let score;
  if (!value || !total) {
    score = -1;
  }

  score = (1 - value / total) * 40 + 60;
  let grade;
  if (score >= 90) {
    grade = "A";
  } else if (score >= 80 && score < 90) {
    grade = "B";
  } else if (score >= 70 && score < 80) {
    grade = "C";
  }
  if (score < 70) {
    grade = "?";
  } else if (score % 10 >= 7 || score === 100) {
    grade += "+";
  } else if (score % 10 <= 3) {
    grade += "-";
  }

  return grade;
}
